(function () {
  if (window.AustropoolFavorites) return;

  var endpoint = '/apps/austropool-order/favorites';
  var favoriteIds = new Set();
  var favorites = [];
  var loading = null;

  function parseResponse(response) {
    return response.text().then(function (text) {
      var body = null;
      try { body = text ? JSON.parse(text) : null; } catch (_error) { body = null; }
      if (!response.ok) throw new Error(body && body.error || 'Favoriten konnten nicht gespeichert werden.');
      return body || {};
    });
  }

  function syncButtons() {
    document.querySelectorAll('[data-b2b-favorite-toggle]').forEach(function (button) {
      var active = favoriteIds.has(button.dataset.variantId || '');
      button.classList.toggle('is-favorite', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('title', active ? 'Aus Favoriten entfernen' : 'Zu Favoriten hinzufügen');
      var label = button.querySelector('[data-favorite-label]');
      if (label) label.textContent = active ? 'Aus Favoriten entfernen' : 'Zu Favoriten hinzufügen';
    });
  }

  function updateState(nextFavorites) {
    favorites = Array.isArray(nextFavorites) ? nextFavorites : [];
    favoriteIds = new Set(favorites.map(function (item) { return item.variantId; }));
    syncButtons();
    document.dispatchEvent(new CustomEvent('austropool:favorites', { detail: { favorites: favorites } }));
    return favorites;
  }

  function load() {
    if (!loading) {
      loading = fetch(endpoint, { headers: { Accept: 'application/json' } })
        .then(parseResponse)
        .then(function (body) { return updateState(body.favorites); })
        .catch(function (error) {
          loading = null;
          throw error;
        });
    }
    return loading;
  }

  function toggle(button) {
    var variantId = button.dataset.variantId || '';
    if (!variantId || button.disabled) return Promise.resolve();
    button.disabled = true;
    button.classList.add('is-loading');
    return fetch(endpoint, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'toggle', variantId: variantId })
    })
      .then(parseResponse)
      .then(function (body) { return updateState(body.favorites); })
      .catch(function (error) {
        window.alert(error instanceof Error ? error.message : 'Favorit konnte nicht gespeichert werden.');
      })
      .finally(function () {
        button.disabled = false;
        button.classList.remove('is-loading');
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-b2b-favorite-toggle]');
    if (!button) return;
    event.preventDefault();
    toggle(button);
  });

  window.AustropoolFavorites = {
    load: load,
    syncButtons: syncButtons,
    getAll: function () { return favorites.slice(); }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      load().catch(function () { syncButtons(); });
    }, { once: true });
  } else {
    load().catch(function () { syncButtons(); });
  }
})();
